import { render, staticRenderFns } from "./AppearanceNewColorCategory.vue?vue&type=template&id=5a9fe887&scoped=true&"
import script from "./AppearanceNewColorCategory.vue?vue&type=script&lang=js&"
export * from "./AppearanceNewColorCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9fe887",
  null
  
)

export default component.exports